export var SnackbarOverrides = function (theme) {
    var _a, _b;
    return ({
        MuiSnackbar: {
            root: (_a = {
                    margin: '20px 16px'
                },
                _a[theme.breakpoints.up('md')] = {
                    margin: '30px',
                },
                _a.minWidth = '288px',
                _a.maxWidth = '768px',
                _a),
        },
        MuiSnackbarContent: {
            root: (_b = {},
                _b[theme.breakpoints.up('sm')] = {
                    width: 'max-content',
                },
                _b.padding = '12px 16px',
                _b.backgroundColor = theme.palette.background.b3,
                _b),
            message: {
                fontSize: theme.typography.fontSizeDefault,
                flex: 1,
                color: theme.palette.primary.contrastText,
                paddingRight: '8px',
                alignSelf: 'flex-start',
                '& #client-snackbar': {
                    flexWrap: 'wrap',
                },
            },
            action: {
                alignSelf: 'flex-start',
                paddingLeft: '8px',
            },
        },
    });
};
//# sourceMappingURL=Snackbar.overrides.js.map